import { atom } from 'jotai';
import { PatientInfo } from '../../../../ts';
import { selectAtom } from 'jotai/vanilla/utils';

// 1. Átomo "Base": Contenedor de datos crudos (Escritura)
export const internalPatientsAtom = atom<PatientInfo[]>([]);

// 2. patientsAtom "Inteligente": Procesado de reglas de negocio (Lectura)
export const patientsAtom = atom((get) => {
  const rawPatients = get(internalPatientsAtom);

  return rawPatients.map((patient) => {

    const reports = patient.reportsDetails ?? [];
    const firstReportStage = reports[0]?.Quote_Stage;
    
    const hasPendingVisits = patient.pendingVisits;
    const hasPendingPayments = patient.pendingPayments; 
    const isWaitingWithPayments = firstReportStage === "Presupuesto en espera" && hasPendingPayments;
    const isAcceptedWithPayments = firstReportStage === "Presupuesto aceptado" && hasPendingPayments;
    const pendingStages = ["Presupuesto en espera", "Presupuesto revisado"];
    const hasPendingStages = reports.some(r => pendingStages.includes(r.Quote_Stage));

    const hasWarnings = isWaitingWithPayments || isAcceptedWithPayments || hasPendingStages || hasPendingVisits;

    return {
      ...patient,
      hasWarnings,
    };
  });
});

// El resto de tus átomos se mantienen igual
export const accumulatedPatientsAtom = atom<PatientInfo[]>([]);

export const isPatientsEmptyAtom = selectAtom(patientsAtom, state => state.length === 0, (a, b) => a !== b);